


































































































































import { Component, Prop, Vue, Ref } from 'vue-property-decorator';
import { HomeMeetingCompletion } from '@/models/CalendarEntries';
import { websiteText } from '@/mixins/websiteTexts';

@Component
export default class HomeMeetingCompletionForm extends Vue {
    [x: string]: any;
    @Prop() originalBookingId!: string;
    @Prop() loading!: boolean;
    @Prop() meetingType!: string;
    @Ref('completionContainer') completionContainer!: HTMLDivElement;
    formSubmitClicked: boolean = false;
    formData: HomeMeetingCompletion = {
        files: null,
        colorSamples: [],
        countertopMaterials: [],
        token: '',
        id: ''
    };
    get colorSamples(): string[] {
        return websiteText('retailer.bookingform.home.colorsamples').split(',') || [];
    }
    get countertopMaterials(): string[] {
        return websiteText('retailer.bookingform.home.countertopmaterials').split(',') || [];
    }
    get formValid(): boolean {
        const formData = this.formData;
        return formData.files !== null || formData.colorSamples.length > 0 || formData.countertopMaterials.length > 0;
    }
    get showHomeMeeting(): boolean {
        if (this.meetingType === 'home') {
            return true;
        }
        return false;
    }
    get filesValid(): boolean {
        return this.formData.files !== null;
    }

    mounted() {
        this.completionContainer.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
        });

    }

    public updateFiles(e: Event) {
        this.formData.files = (e.target as HTMLInputElement).files;
    }
    public submitBooking() {
        this.formSubmitClicked = true;
        if (this.formValid) {
            let form = new FormData();
            form.append('id', this.originalBookingId);
            form.append('colorSamples', this.formData.colorSamples.join(','));
            form.append('countertopMaterials', this.formData.countertopMaterials.join(','));

            if (this.formData.files !== null) {
                Array.from(Array(this.formData.files.length).keys()).map(x => {
                    form.append('file[]', this.formData.files[x], this.formData.files[x].name);
                });
            }
            this.$emit('submitHomeMeetingCompletion', form);
        }
    }
}
